/* global BigInt */

import React, { Component } from 'react';
import Select, { components } from 'react-select'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal'
import TheWill from '../Contract/TheWill.json'
import { ethers } from "ethers"
import { chainIDs, UnlimitedAmount } from '../Utils/Constants'
import closeModalPic from '../content/close_modal.svg'
import buttonClosePic from '../content/button_close.svg'
import PolygonPic from '../content/poligon.svg'
import BinancePic from '../content/binance.svg'
import EthereumPic from '../content/ethereum.svg'
import AvalanchePic from '../content/avalanche.svg'
import OptimismPic from '../content/optimism.svg'
import ArbitrumPic from '../content/arbitrum.svg'
import ConfiPic from '../content/confi.svg'
import closePic from '../content/button_close.svg'
import btnTelegram from '../content/btnTelegram.svg'
import btnCalendar from '../content/btnCalendar.svg'
import btnEmail from '../content/btnEmail.svg'
import infoBtn from '../content/info-btn.svg'
import linkBtn from '../content/link-btn.png'
import ERC20 from '../Contract/ERC20.json'
import BinanceMainnetTokens from '../Utils/tokens/binanceMainnet.json'
import BinanceTestnetTokens from '../Utils/tokens/binanceTestnet.json'
import MumbaiTokens from '../Utils/tokens/mumbai.json'
import GoerliTokens from '../Utils/tokens/goerli.json'
import UniswapTokens from '../Utils/tokens/uniswap.json'
import AvalancheTokens from '../Utils/tokens/avalanche.json'
import OptimismTokens from '../Utils/tokens/optimism.json'
import { select } from '../Utils/styles/select'
import { tooltipText } from '../Utils/tooltipText';

const { Option, SingleValue } = components;

const tokenIconCache = new Map();
const tokenIconPrefetchQueue = new Set();

const TokenIcon = ({ src, alt }) => {
    const [status, setStatus] = React.useState(() => {
        if (!src) {
            return 'failed';
        }
        return tokenIconCache.get(src) || 'idle';
    });

    React.useEffect(() => {
        if (!src) {
            setStatus('failed');
            return undefined;
        }
        const cachedStatus = tokenIconCache.get(src);
        if (cachedStatus === 'loaded' || cachedStatus === 'failed') {
            setStatus(cachedStatus);
            return undefined;
        }
        let isMounted = true;
        const img = new Image();
        img.decoding = 'async';
        img.referrerPolicy = 'no-referrer';
        img.src = src;
        img.onload = () => {
            tokenIconCache.set(src, 'loaded');
            if (isMounted) {
                setStatus('loaded');
            }
        };
        img.onerror = () => {
            tokenIconCache.set(src, 'failed');
            if (isMounted) {
                setStatus('failed');
            }
        };
        return () => {
            isMounted = false;
        };
    }, [src]);

    if (status !== 'loaded') {
        const fallbackLetter = (alt || '?').charAt(0).toUpperCase();
        return (
            <span className="select-pic select-pic--fallback" aria-hidden="true">
                {fallbackLetter}
            </span>
        );
    }
    return (
        <img
            className="select-pic"
            src={src}
            alt={alt}
            loading="lazy"
            decoding="async"
            referrerPolicy="no-referrer"
            onError={() => {
                tokenIconCache.set(src, 'failed');
                setStatus('failed');
            }}
        />
    );
};

const IconOption = props => (
    <Option {...props}>
        <TokenIcon src={props.data.icon} alt={props.data.label} />
        {props.data.label}
    </Option>
);

const IconSingleValue = props => (
    <SingleValue {...props}>
        <span className="select-value-with-icon">
            <TokenIcon src={props.data.icon} alt={props.data.label} />
            <span>{props.data.label}</span>
        </span>
    </SingleValue>
);

const styles = {
    modal_new_will: {
        // maxWidth: '700px',
        // left: '25%',
        // width: '100%',
        // top: '1%',
        // background: '#1B232A',
    },
}

Date.prototype.addDays = function (days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

class NewWill extends Component {
    constructor(props) {
        super(props);
        this.tokensOptionsByNetwork = new Map();
        this.networkSwitchTimeout = null;
        this.state = {
            signer: null,
            signerAddress: '',
            tokenAddress: '',
            amount: ethers.constants.MaxUint256.toString(),
            show: false,
            showWalletNotExist: false,
            network: '',
            approved: false,
            tokensValue: '',
            contractAddress: props.contractAddress,
            year: 2,
            month: 0,
            day: 0,
            heirAddress: '',
            heirAddressShort: '',
            contract: null,
            showConfirm: false,
            showAwait: false,
            showError: false,
            newWillDone: false,
            showEventConfirmed: false,
            isUnlimitedAmount: true,
            errortext: '',
            notificationsOn: false,
            networkPic: EthereumPic,
            googleCalendarDateText: '',
            processingText: '',
            confirmedText: '',
            hash: '',
            limitedText: 'unlimited',
            isAddress: true,
            isNetworkSwitching: false,
            blockingModalType: 'wallet'
        };
    }

    componentDidMount = async () => {
        try {
            const signer = this.props.signer
            const signerAddress = this.props.signerAddress
            let contract = null
            if (this.props.contractAddress && ethers.utils.isAddress(this.props.contractAddress) && signer) {
                try {
                    contract = new ethers.Contract(this.props.contractAddress, TheWill.abi, signer)
                } catch (contractError) {
                    console.error(contractError)
                }
            }
            this.createTime()
            const networkPic = this.getNetworkPic(this.props.network)
            const body = document.getElementsByTagName('body')
            const App = document.getElementsByClassName('App')
            const MainText = document.getElementsByClassName('main-text')
            const HeaderBoxes = document.getElementsByClassName('header_boxes')
            const NumberOfWills = document.getElementsByClassName('number-of-wills')
            const _container = document.getElementsByClassName('_container')
            const blockTwo = document.getElementsByClassName('block-two')
            const blockThree = document.getElementsByClassName('block-three')
            const pageData = document.getElementsByClassName('page-data')
            // const your_inheritances = document.getElementsByClassName('your_inheritances_ul')
            //for show confirm
            const modalContent = document.getElementsByClassName('modal-content')
            const modalConfirm = document.getElementsByClassName('modal-confirm')
            const modalConfirmText = document.getElementsByClassName('modal-confirm_text')
            const modalConfirmH2 = document.getElementsByClassName('modal-confirm_h2')
            const modalConfirmLoader = document.getElementsByClassName('ml-loader')
            //for done modal
            const modalDone = document.getElementsByClassName('modal-await')
            const modalAwaitText = document.getElementsByClassName('modal-await_text')
            const imageInModalDone = document.getElementById('modal-done-image')
            body[0].addEventListener('click', (event) => {
                const exist = document.getElementsByClassName('fade will-block modal show')
                if (
                    (this.state.show)
                    &&
                    (
                        event.target === App[0]
                        ||
                        event.target === MainText[0]
                        ||
                        event.target === HeaderBoxes[0]
                        ||
                        event.target === NumberOfWills[0]
                        ||
                        event.target === _container[0]
                        ||
                        event.target === blockTwo[0]
                        ||
                        event.target === blockTwo[1]
                        ||
                        event.target === blockThree[0]
                        ||
                        event.target === pageData[0]
                        ||
                        event.target === exist[0]
                    )
                ) {
                    this.handleClose()
                }
                if (
                    this.state.showConfirm
                    &&
                    event.target !== modalContent[0]
                    &&
                    event.target !== modalContent[1]
                    &&
                    event.target !== modalConfirm[0]
                    &&
                    event.target !== modalConfirmText[0]
                    &&
                    event.target !== modalConfirmH2[0]
                    &&
                    event.target !== modalConfirmLoader[0]

                ) {
                    this.handleCloseConfirm()
                }
                if (
                    this.state.newWillDone
                    &&
                    event.target !== modalDone[0]
                    &&
                    event.target !== modalAwaitText[0]
                    &&
                    event.target !== modalContent[0]
                    &&
                    event.target !== imageInModalDone
                ) {
                    this.handleCloseDoneNewWill()
                }

            })
            this.setState({ signer, signerAddress, contract, networkPic })
        } catch (error) {
            console.error(error)
        }
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.network !== this.props.network ||
            prevProps.contractAddress !== this.props.contractAddress
        ) {
            if (!this.hasWalletSession()) {
                if (this.state.isNetworkSwitching) {
                    this.setState({ isNetworkSwitching: false })
                }
                return
            }
            if (this.networkSwitchTimeout) {
                clearTimeout(this.networkSwitchTimeout)
            }
            if (!this.state.isNetworkSwitching) {
                this.setState({ isNetworkSwitching: true })
            }
            this.networkSwitchTimeout = setTimeout(() => {
                this.setState({ isNetworkSwitching: false })
                this.networkSwitchTimeout = null
            }, 700)
        }
    }

    componentWillUnmount() {
        if (this.networkSwitchTimeout) {
            clearTimeout(this.networkSwitchTimeout)
        }
    }

    getTokensLists() {
        if (this.props.network === chainIDs.BinanceMainnet) {
            return BinanceMainnetTokens.tokens
        } else if (this.props.network === chainIDs.Polygon) {
            return UniswapTokens.tokens.filter((v) => v.chainId === chainIDs.Polygon)
        } else if (this.props.network === chainIDs.EthereumMainnet) {
            return UniswapTokens.tokens.filter((v) => v.chainId === chainIDs.EthereumMainnet)
        } else if (this.props.network === chainIDs.Mumbai) {
            return MumbaiTokens.tokens
        } else if (this.props.network === chainIDs.Goerli) {
            return GoerliTokens.tokens
        } else if (this.props.network === chainIDs.BinanceTestnet) {
            return BinanceTestnetTokens.tokens
        } else if (this.props.network === chainIDs.AvalancheMainnet) {
            return AvalancheTokens.tokens.filter((v) => v.chainId === chainIDs.AvalancheMainnet)
        } else if (this.props.network === chainIDs.OptimismMainnet) {
            return OptimismTokens.tokens.filter((v) => v.chainId === chainIDs.OptimismMainnet)
        } else if (this.props.network === chainIDs.ArbitrumMainnet) {
            return UniswapTokens.tokens.filter((v) => v.chainId === chainIDs.ArbitrumMainnet)
        }
        return []
    }

    getTokenOptions() {
        const networkId = this.props.network;
        if (this.tokensOptionsByNetwork.has(networkId)) {
            return this.tokensOptionsByNetwork.get(networkId);
        }
        const NATIVE_PSEUDO_ADDRESSES = new Set([
            '0x0000000000000000000000000000000000000000',
            '0x0000000000000000000000000000000000001010',
            '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee'
        ]);
        const options = this.getTokensLists()
            .filter((token) => token && token.address && token.symbol)
            .filter((token) => !NATIVE_PSEUDO_ADDRESSES.has(token.address.toLowerCase()))
            .map((token) => ({
                value: token.address,
                label: token.symbol,
                icon: token.logoURI || ''
            }));
        this.tokensOptionsByNetwork.set(networkId, options);
        return options;
    }

    getNetworkPic(networkId) {
        switch (networkId) {
            case chainIDs.Mumbai:
            case chainIDs.Polygon:
                return PolygonPic
            case chainIDs.Goerli:
            case chainIDs.EthereumMainnet:
                return EthereumPic
            case chainIDs.BinanceTestnet:
            case chainIDs.BinanceMainnet:
                return BinancePic
            case chainIDs.AvalancheMainnet:
                return AvalanchePic
            case chainIDs.OptimismMainnet:
                return OptimismPic
            case chainIDs.ArbitrumMainnet:
                return ArbitrumPic
            default:
                return EthereumPic
        }
    }

    prefetchTokenIcons() {
        const priorityTokens = this.getTokenOptions().slice(0, 40);
        priorityTokens.forEach((token) => {
            if (!token.icon) {
                return;
            }
            if (tokenIconCache.has(token.icon) || tokenIconPrefetchQueue.has(token.icon)) {
                return;
            }
            tokenIconPrefetchQueue.add(token.icon);
            const img = new Image();
            img.decoding = 'async';
            img.referrerPolicy = 'no-referrer';
            img.src = token.icon;
            img.onload = () => {
                tokenIconCache.set(token.icon, 'loaded');
                tokenIconPrefetchQueue.delete(token.icon);
            };
            img.onerror = () => {
                tokenIconCache.set(token.icon, 'failed');
                tokenIconPrefetchQueue.delete(token.icon);
            };
        });
    }

    async approve() {
        try {
            const { tokensValue } = this.state
            const signer = this.props.signer || this.state.signer
            const contractAddress = this.props.contractAddress || this.state.contractAddress
            if (!signer) {
                this.handleShowError('Wallet is not connected')
                setTimeout(() => this.handleCloseError(), 10000)
                return
            }
            if (!tokensValue || !ethers.utils.isAddress(tokensValue)) {
                this.handleShowError('Please select a token to inherit')
                setTimeout(() => this.handleCloseError(), 10000)
                return
            }
            if (!contractAddress || !ethers.utils.isAddress(contractAddress)) {
                this.handleShowError('dWill not exist on this network')
                setTimeout(() => this.handleCloseError(), 10000)
                return
            }
            const _token = new ethers.Contract(tokensValue, ERC20.abi, signer)
            this.handleShowConfirm()
            const symbol = await _token.symbol()
            await _token.approve(contractAddress, ethers.constants.MaxUint256)
                .then(async (tx) => {
                    this.handleShowAwait(`Approve ${symbol}`)
                    await tx.wait()
                        .then(() => {
                            this.handleCloseAwait()
                            this.handleShowEventConfirmed(`Approved ${symbol}`, tx.hash)
                            setTimeout(() => {
                                this.handleCloseEventConfirmed()
                            }, 5000)
                            this.setState({
                                approved: true
                            })
                        })
                })
                .catch(err => {
                    console.log(err)
                    const errMessage = (err && err.message) || ''
                    const errReason = (err && err.reason) || ''
                    if (errMessage.includes('resolver or addr is not') || errReason.includes('resolver or addr is not')) {
                        this.handleShowError('Please select a token to inherit')
                    } else if (errMessage.includes('user rejected') || errReason.includes('user rejected')) {
                        // user cancelled in wallet -- silent
                    } else {
                        this.handleShowError(errMessage || 'Approval failed')
                    }
                    setTimeout(() => {
                        this.handleCloseError()
                    }, 10000)
                    this.handleCloseConfirm()
                    this.handleCloseAwait()
                })
        } catch (error) {
            console.log(error)
        }
    }

    createTime() {
        try {
            const { year, month, day } = this.state
            let date = new Date()
            date = new Date(date.setFullYear(date.getFullYear() + parseInt(year)))
            date = new Date(date.setMonth(date.getMonth() + parseInt(month)))
            date = date.addDays(parseInt(day))
            let _gTime = date.toISOString().replaceAll('-', '').replaceAll(':', '')
            _gTime = _gTime.slice(0, _gTime.indexOf('.'))
            this.setState({
                googleCalendarDateText: `${_gTime}Z`
            })
            return date
        } catch (error) {
            if (
                (this.state.year === '' || this.state.month === '' || this.state.day === '')
                ||
                (this.state.year === 0 && this.state.month === 0 && this.state.day === 0)
                ||
                (isNaN(parseInt(this.state.year)) || isNaN(parseInt(this.state.month)) || isNaN(parseInt(this.state.day)))
            ) { } else {
                this.handleShowError('Something wrong with time')
                setTimeout(() => {
                    this.handleCloseError()
                }, 10000)
            }
        }
    }

    async newWill() {
        try {
            const { heirAddress, amount, isUnlimitedAmount, tokensValue } = this.state
            const signer = this.props.signer || this.state.signer
            const contractAddress = this.props.contractAddress || this.state.contractAddress
            if (!signer) {
                this.handleShowError('Wallet is not connected')
                setTimeout(() => this.handleCloseError(), 10000)
                return
            }
            const contract = this.state.contract || (
                contractAddress && ethers.utils.isAddress(contractAddress)
                    ? new ethers.Contract(contractAddress, TheWill.abi, signer)
                    : null
            )
            if (!contract) {
                this.handleShowError('dWill not exist on this network')
                setTimeout(() => this.handleCloseError(), 10000)
                return
            }
            const _token = new ethers.Contract(tokensValue, ERC20.abi, signer)
            let date = this.createTime()
            let timeUnixWhenWithdraw = 0;
            timeUnixWhenWithdraw = Math.floor(date.getTime() / 1000)
            let sendTo = isUnlimitedAmount === true ? ethers.constants.MaxUint256 : BigInt(amount * Math.pow(10, await _token.decimals())).toString()
            this.handleShowConfirm()
            await contract.addWill(heirAddress, tokensValue, timeUnixWhenWithdraw.toString(), sendTo)
                .then(async (tx) => {
                    this.handleShowAwait('New dWill creation')
                    await tx.wait()
                    this.handleCloseAwait()
                    this.handleClose()
                    this.handleShowDoneNewWill(tx.hash)
                    setTimeout(() => {
                        window.location = '/'
                    }, 2000)
                    setTimeout(() => {
                        this.handleCloseDoneNewWill()
                    }, 10000)
                })
        } catch (error) {
            console.error(error)
            if (error.message.includes('cannot estimate gas; transaction may fail or may require manual gas limit')) {
                this.handleShowError(
                    'Something went wrong. Maybe you have already bequeathed all your tokens or you are trying to bequeath all tokens to one address when there is already some amount for another.'
                )
            }
            if (error.message.includes('resolver or addr is not configured')) {
                this.handleShowError('Добавьте адрес')
            }
            if (error.message.includes('invalid BigNumber string')) {
                this.handleShowError('Please specify the correct time for the will activation timer')
            }
            if (error.message.includes('user rejected transaction')) { }
            if (error.message.includes('Not enough allowance')) {
                this.handleShowError('Not enough allowance')
            }
            setTimeout(() => {
                this.handleCloseError()
            }, 10000)
            this.handleCloseConfirm()
            this.handleCloseAwait()
        }
    }

    async onChangeAmount(event) {
        try {
            const { tokensValue, contract } = this.state
            const signer = this.props.signer || this.state.signer
            const signerAddress = this.props.signerAddress || this.state.signerAddress
            const contractAddress = this.props.contractAddress || this.state.contractAddress
            if (tokensValue === '') throw Error('resolver or addr is not configured')
            if (!signer) throw Error('signer is not configured')
            if (parseFloat(event.target.value) >= 0) {
                this.setState({
                    amount: event.target.value
                })
            }
            if (event.target.value === '') {
                this.setState({
                    amount: ''
                })
            }
            const _token = new ethers.Contract(tokensValue, ERC20.abi, signer)
            const allowance = await _token.allowance(signerAddress, contractAddress)
            if (allowance.toString() === ethers.constants.MaxUint256.toString()) {
                this.setState({
                    approved: true
                })
            } else {
                const decimals = await _token.decimals()
                const allWillsAmountThisToken = await contract.willAmountForToken(signerAddress, _token.address)
                this.changeApproved(
                    BigInt(allowance),
                    BigInt(allWillsAmountThisToken) + BigInt(event.target.value * Math.pow(10, decimals)),
                    decimals
                )
            }
        } catch (error) {
            if (error.message.includes('resolver or addr is not configured')) {
                if (this.state.contractAddress === '') {
                    this.handleShowError(`dWill not exist on this network`)
                }
                if (this.state.tokensValue === '') {
                    this.handleShowError('Please select a token to inherit')
                }
            }
            setTimeout(() => {
                this.handleCloseError()
            }, 10000)
        }
    }

    async onChangeUnlimitedAmount() {
        try {
            const { tokensValue, isUnlimitedAmount } = this.state
            const signer = this.props.signer || this.state.signer
            const signerAddress = this.props.signerAddress || this.state.signerAddress
            const contractAddress = this.props.contractAddress || this.state.contractAddress
            //max amount uint256
            this.setState({
                amount: isUnlimitedAmount === false ? ethers.constants.MaxUint256.toString() : '',
                isUnlimitedAmount: isUnlimitedAmount === true ? false : true,
                limitedText: isUnlimitedAmount === true ? 'limited by' : 'unlimited'
            })
            if (!signer || !tokensValue || !ethers.utils.isAddress(tokensValue) || !ethers.utils.isAddress(contractAddress || '')) {
                return
            }
            const _token = new ethers.Contract(tokensValue, ERC20.abi, signer)
            const allowance = await _token.allowance(signerAddress, contractAddress)
            if (allowance.toString() === ethers.constants.MaxUint256.toString()) {
                this.setState({
                    approved: true
                })
            } else {
                this.changeApproved(BigInt(allowance), BigInt(this.state.amount))
            }
        } catch (error) {
            console.error(error)
            if (error.message && error.message.includes('resolver or addr is not configured')) {
                // this.setState({
                //     amount: '',
                //     isUnlimitedAmount: false
                // })
                // this.handleShowError('Выберите токен')
            }
            setTimeout(() => {
                this.handleCloseError()
            }, 10000)
        }
    }

    async onSetMaxAmount() {
        try {
            const { tokensValue } = this.state
            const signer = this.props.signer || this.state.signer
            const signerAddress = this.props.signerAddress || this.state.signerAddress
            const contractAddress = this.props.contractAddress || this.state.contractAddress
            if (!signer || !signerAddress) {
                this.handleShowError('Wallet is not connected')
                setTimeout(() => this.handleCloseError(), 10000)
                return
            }
            if (!tokensValue || !ethers.utils.isAddress(tokensValue)) {
                this.handleShowError('Please select a token to inherit')
                setTimeout(() => this.handleCloseError(), 10000)
                return
            }
            if (!contractAddress || !ethers.utils.isAddress(contractAddress)) {
                this.handleShowError('dWill not exist on this network')
                setTimeout(() => this.handleCloseError(), 10000)
                return
            }
            const willsContract = this.state.contract
                || new ethers.Contract(contractAddress, TheWill.abi, signer)
            const _token = new ethers.Contract(tokensValue, ERC20.abi, signer)
            const [allowance, decimals, balance, allWillsAmountThisToken] = await Promise.all([
                _token.allowance(signerAddress, contractAddress),
                _token.decimals(),
                _token.balanceOf(signerAddress),
                willsContract.willAmountForToken(signerAddress, _token.address)
            ])
            const divisor = ethers.BigNumber.from(10).pow(decimals)
            const wholeAmount = balance.div(divisor).toString()
            this.setState({
                amount: wholeAmount,
                contract: willsContract
            })
            if (allowance.toString() === ethers.constants.MaxUint256.toString()) {
                this.setState({ approved: true })
            } else {
                this.changeApproved(
                    BigInt(allowance.toString()),
                    BigInt(balance.toString()) + BigInt(allWillsAmountThisToken.toString()),
                    decimals
                )
            }
        } catch (error) {
            console.error(error)
            const msg = (error && (error.reason || error.message)) || ''
            if (msg.includes('Unauthorized')) {
                this.handleShowError('RPC of your wallet is unavailable. Switch RPC in wallet settings and try again.')
            } else if (msg.includes('missing revert data') || msg.includes('CALL_EXCEPTION')) {
                this.handleShowError('This token does not support standard ERC20 calls (e.g. native gas token). Pick a different token.')
            } else {
                this.handleShowError('Failed to read balance. Please try again.')
            }
            setTimeout(() => this.handleCloseError(), 10000)
        }
    }

    changeApproved(allowance, amount) {
        try {
            if (allowance >= amount) {
                this.setState({
                    approved: true
                })
            } else {
                this.setState({
                    approved: false
                })
            }
        } catch (error) {
            console.error(error.reason)
            if (error.reason.includes('invalid decimal value')) {
                this.state({
                    errortext: 'Неправильно введена сумма'
                })
            }
        }
    }

    async onChangeTokens(event) {
        try {
            const { amount, contract } = this.state
            const signer = this.props.signer || this.state.signer
            const signerAddress = this.props.signerAddress || this.state.signerAddress
            const contractAddress = this.props.contractAddress || this.state.contractAddress
            if (event.value === '') throw Error('token not exist here')
            this.setState({
                tokensValue: event.value
            })
            if (!signer || !ethers.utils.isAddress(event.value) || !ethers.utils.isAddress(contractAddress || '') || !contract) {
                return
            }
            const _token = new ethers.Contract(event.value, ERC20.abi, signer)
            const allowance = await _token.allowance(signerAddress, contractAddress)
            const decimals = await _token.decimals()
            const allWillsAmountThisToken = await contract.willAmountForToken(signerAddress, _token.address)
            this.changeApproved(
                BigInt(allowance),
                BigInt(allWillsAmountThisToken) + BigInt(amount === UnlimitedAmount ? UnlimitedAmount : amount * Math.pow(10, decimals)),
                decimals
            )
            this.changeApproved(allowance, amount)
        } catch (error) {
            console.log(error && error.message)
            const errMessage = (error && error.message) || ''
            if (errMessage.includes('resolver or addr is not configured')) {
                if (this.state.contractAddress === '') {
                    this.handleShowError('dWill not exist on this network')
                }
            } else if (errMessage.includes('token not exist here')) {
                this.handleShowError('Not existed token')
            }
            setTimeout(() => {
                this.handleCloseError()
            }, 10000)
        }
    }

    disableAmountInput() {
        return this.state.tokensValue === '';
    }

    onChangeYear(event) {
        this.setState({
            year: parseInt(event.target.value)
        }, () => {
            this.createTime()
        })
    }

    onChangeMonth(event) {
        this.setState({
            month: parseInt(event.target.value)
        }, () => {
            this.createTime()
        })
    }

    onChangeDay(event) {
        this.setState({
            day: parseInt(event.target.value)
        }, () => {
            this.createTime()
        })
    }

    onChangeHeirAddress(event) {
        this.setState({
            heirAddress: event.target.value,
            isAddress: event.target.value === '' ? true : ethers.utils.isAddress(event.target.value)
        }, () => {
            this.setState({
                heirAddressShort: this.state.heirAddress.slice(0, 6) + '...' + this.state.heirAddress.slice(this.state.heirAddress.length - 4, this.state.heirAddress.length)
            })
        })
    }

    changeNotifications() {
        this.createTime()
        this.setState({
            notificationsOn: this.state.notificationsOn === true ? false : true
        })
    }

    changeDelivery() {
        this.createTime()
        this.setState({
            deliveryOn: this.state.deliveryOn === true ? false : true
        })
    }

    changeMessage() {
        this.createTime()
        this.setState({
            messageOn: this.state.messageOn === true ? false : true
        })
    }

    onChangeUnlimitedAmount = this.onChangeUnlimitedAmount.bind(this)
    onSetMaxAmount = this.onSetMaxAmount.bind(this)
    approve = this.approve.bind(this)
    newWill = this.newWill.bind(this)
    onChangeTokens = this.onChangeTokens.bind(this)
    onChangeAmount = this.onChangeAmount.bind(this)
    changeApproved = this.changeApproved.bind(this)
    onChangeYear = this.onChangeYear.bind(this)
    onChangeMonth = this.onChangeMonth.bind(this)
    onChangeDay = this.onChangeDay.bind(this)
    onChangeHeirAddress = this.onChangeHeirAddress.bind(this)
    changeNotifications = this.changeNotifications.bind(this)
    changeDelivery = this.changeDelivery.bind(this)
    changeMessage = this.changeMessage.bind(this)

    handleClose = () => this.setState({
        show: false,
        approved: false,
        year: 2,
        month: 0,
        day: 0,
        heirAddress: '',
        isUnlimitedAmount: true,
        amount: ethers.constants.MaxUint256.toString(),
        tokensValue: '',
        limitedText: 'unlimited',
        isAddress: true,
        notificationsOn: false
    });
    handleShow = () => {
        this.prefetchTokenIcons();
        this.setState({ show: true })
    };

    handleClose = this.handleClose.bind(this)
    handleShow = this.handleShow.bind(this)

    handleShowConfirm = () => this.setState({ showConfirm: true })
    handleShowAwait = (processingText) => {
        const body = document.getElementsByTagName('body')
        body[0].classList.add('small-modal')
        this.setState({ showConfirm: false, showAwait: true, processingText })
    }
    handleCloseConfirm = () => this.setState({ showConfirm: false })
    handleCloseAwait = () => {
        const body = document.getElementsByTagName('body')
        body[0].classList.remove('small-modal')
        this.setState({ showAwait: false })
    }
    handleShowConfirm = this.handleShowConfirm.bind(this)
    handleShowAwait = this.handleShowAwait.bind(this)
    handleCloseConfirm = this.handleCloseConfirm.bind(this)
    handleCloseAwait = this.handleCloseAwait.bind(this)

    handleShowError = (errortext) => {
        const body = document.getElementsByTagName('body')
        body[0].classList.add('small-modal')
        this.setState({ showError: true, errortext })
    }
    handleCloseError = () => {
        const body = document.getElementsByTagName('body')
        body[0].classList.remove('small-modal')
        this.setState({ showError: false })
    }

    handleShowError = this.handleShowError.bind(this)
    handleCloseError = this.handleCloseError.bind(this)

    handleShowWalletNotExist = (blockingModalType = 'wallet') => this.setState({ showWalletNotExist: true, blockingModalType })
    handleCloseWalletNotExist = () => this.setState({ showWalletNotExist: false })

    handleShowWalletNotExist = this.handleShowWalletNotExist.bind(this)
    handleCloseWalletNotExist = this.handleCloseWalletNotExist.bind(this)

    hasWalletSession() {
        const hasLocalSession = Boolean(
            localStorage.getItem('account') &&
            (localStorage.getItem('wallet') || localStorage.getItem('walletconnect'))
        )
        return hasLocalSession || this.isSignerReady()
    }

    isSignerReady() {
        return Boolean(this.props.signer && this.props.signerAddress)
    }

    isNetworkReady() {
        return Boolean(this.props.network && this.props.contractAddress)
    }

    isCreateTemporarilyBlocked() {
        return this.state.isNetworkSwitching
    }

    handleNewWillButtonClick = () => {
        if (this.state.isNetworkSwitching) {
            return
        }
        if (!this.hasWalletSession()) {
            this.handleShowWalletNotExist('wallet')
            return
        }
        if (!this.isSignerReady() || !this.isNetworkReady()) {
            this.handleShowWalletNotExist('network')
            return
        }
        this.handleShow()
    }

    handleNewWillButtonClick = this.handleNewWillButtonClick.bind(this)

    handleShowDoneNewWill = (hash) => this.setState({ newWillDone: true, hash })
    handleCloseDoneNewWill = () => this.setState({ newWillDone: false })

    handleShowDoneNewWill = this.handleShowDoneNewWill.bind(this)
    handleCloseDoneNewWill = this.handleCloseDoneNewWill.bind(this)

    handleShowEventConfirmed = (confirmedText, hash) => {
        const body = document.getElementsByTagName('body')
        body[0].classList.add('small-modal')
        this.setState({ showEventConfirmed: true, confirmedText, hash })
    }
    handleCloseEventConfirmed = () => {
        const body = document.getElementsByTagName('body')
        body[0].classList.add('small-modal')
        this.setState({ showEventConfirmed: false })
    }

    handleShowEventConfirmed = this.handleShowEventConfirmed.bind(this)
    handleCloseEventConfirmed = this.handleCloseEventConfirmed.bind(this)

    render() {
        const isCreateTemporarilyBlocked = this.isCreateTemporarilyBlocked()
        const isNetworkModal = this.state.blockingModalType === 'network'
        const blockingModalTitle = isNetworkModal ? 'Network is not selected' : 'Connect wallet'
        const blockingModalText = isNetworkModal
            ? 'Please select a supported network in your wallet and try again.'
            : 'To create a dWill, connect a Web3 wallet in the header.'

        return (
            <><div>
                <Button
                    id="newwill-button"
                    variant="primary"
                    className="btn-new-will"
                    onClick={this.handleNewWillButtonClick}
                    disabled={isCreateTemporarilyBlocked}
                    title={isCreateTemporarilyBlocked ? 'Loading network data...' : undefined}
                >
                    {
                        isCreateTemporarilyBlocked
                            ? (
                                <span className="btn-new-will__loading">
                                    <span className="btn-new-will__spinner" aria-hidden="true"></span>
                                    Loading
                                </span>
                            )
                            : 'New dWill'
                    }
                </Button>
                <div className='modal_fade'></div>
                <Modal show={this.state.showWalletNotExist} onHide={this.handleCloseWalletNotExist} className='modal_content modal-wallet-not-exist' centered>
                    <Modal.Header className='modal-wallet-not-exist__header'>
                        <Button className='bnt_close' onClick={this.handleCloseWalletNotExist}>
                            <img src={closeModalPic} alt="close" />
                        </Button>
                        <Modal.Title className='modal_title modal-wallet-not-exist__title'>{blockingModalTitle}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='modal-wallet-not-exist__body'>
                        <p className='modal-wallet-not-exist__text'>{blockingModalText}</p>
                        {
                            isNetworkModal
                                ? (
                                    <p className='modal-wallet-not-exist__text modal-wallet-not-exist__text--small'>
                                        If the network was switched recently, wait a moment and try again.
                                    </p>
                                )
                                : (
                                    <>
                                        <p className='modal-wallet-not-exist__label'>What is a wallet?</p>
                                        <p className='modal-wallet-not-exist__text modal-wallet-not-exist__text--small'>
                                            Wallets are used to send, receive, and store digital assets. Connecting a wallet lets you interact with apps.{' '}
                                            <a href="https://metamask.io/" target="_blank" rel="noreferrer">Install the wallet.</a>
                                        </p>
                                    </>
                                )
                        }
                    </Modal.Body>
                </Modal>
                <Modal id="willmodal" show={this.state.show} className='will-block' style={styles.modal_new_will}>
                    <div className="will-block__wrapper">
                        <Modal.Header className='modal_new_will'>
                            <Button className='bnt_close' onClick={this.handleClose}>
                                <img src={buttonClosePic} alt="close" />
                            </Button>
                            <Modal.Title className='modal_title'>New dWill</Modal.Title>
                            <hr />
                        </Modal.Header>
                        <Modal.Body>
                            <div className="modal-body__row">
                                <div className="your-wills__header">
                                    <div>
                                        I bequeath my
                                    </div>
                                    {
                                        <Select
                                            styles={select}
                                            name="tokens"
                                            onChange={this.onChangeTokens}
                                            placeholder="Select token..."
                                            options={this.getTokenOptions()}
                                            components={{ Option: IconOption, SingleValue: IconSingleValue }}
                                        />
                                    }
                                </div>
                            </div>
                            <div className="modal-body__row">
                                <div className="your-wills__count">
                                    <span>Amount</span>
                                    <div className="your-wills__checkbox">
                                        <input id="unlimited" type="checkbox" onChange={this.onChangeUnlimitedAmount} checked={this.state.isUnlimitedAmount} className="form-check-input mt-0" />
                                        <label htmlFor="unlimited">{this.state.limitedText}</label>
                                    </div>
                                    <div className="your-wills__info-message" data-title={tooltipText.tokens}>
                                        <img src={infoBtn} alt="Info"></img>
                                    </div>
                                </div>
                                <div style={{ opacity: this.state.isUnlimitedAmount ? 0.4 : 1, pointerEvents: this.state.isUnlimitedAmount ? 'none' : 'auto' }} className="your-wills__max mt-0">
                                    <input disabled={this.state.isUnlimitedAmount || this.disableAmountInput()} onChange={this.onChangeAmount} value={this.state.isUnlimitedAmount ? '' : this.state.amount} min="0" placeholder={this.state.isUnlimitedAmount ? "All tokens" : "Enter the amount"} type="number" className="input-group mb-3" />
                                    <Button variant="outline-success" disabled={this.state.isUnlimitedAmount || this.disableAmountInput()} onClick={this.onSetMaxAmount}>
                                        All
                                    </Button>
                                </div>
                            </div>
                            <div className='modal-body__row modal-body__row-direction'>From the wallet <a href={`${this.props.networkProvider}/address/${this.props.signerAddress || this.state.signerAddress || ''}`} target="_blank" rel="noreferrer" className='modal_wallet_link'>{(() => {
                                const addr = this.props.signerAddress || this.state.signerAddress || ''
                                if (!addr) return ''
                                return `${addr.slice(0, 6)}...${addr.slice(-4)}`
                            })()}</a>on the <i className="br"></i> {this.props.networkName} network
                                <img src={this.props.networkPic || this.getNetworkPic(this.props.network)} alt="networkpic" />
                                <div className="your-wills__info-message" data-title={tooltipText.network}>
                                    <img src={infoBtn} alt="Info"></img>
                                </div></div>
                            <div className="your-wills__wallet modal-body__row">
                                <div className="your-wills__wallet-row">
                                    To trusted wallet
                                    <div className="your-wills__info-message" data-title={tooltipText.wallet}>
                                        <img src={infoBtn} alt="Info"></img>
                                    </div>
                                </div>
                                <input placeholder={ethers.constants.AddressZero} onChange={this.onChangeHeirAddress} value={this.state.currentEditHeirAddress} className="input-group mb-3" required="required" />
                                <p style={{ display: this.state.isAddress ? 'none' : 'block' }}>Incorrect wallet address format</p>
                            </div>
                            <div className="modal-body__row">

                                <div className='modal_title-time-will'>{"Provided that I will be inactive, starting from the moment of dWill creation, more than:"}

                                </div>
                                <div className="will-date">
                                    <div className="will-date__row">
                                        <input type="number" max="100" onChange={this.onChangeYear} value={this.state.year} className="input-group input-group-year" />
                                        <label>Years</label><br />
                                    </div>
                                    <div className="will-date__row">
                                        <input type="number" onChange={this.onChangeMonth} value={this.state.month} className="input-group input-group-month" />
                                        <label>Months</label><br />
                                    </div>
                                    <div className="will-date__row">
                                        <input type="number" onChange={this.onChangeDay} value={this.state.day} className="input-group input-group-days" />
                                        <label>Days</label><br />
                                    </div>
                                    <div className="your-wills__info-message" data-title={tooltipText.time}>
                                        <img src={infoBtn} alt="Info"></img>
                                    </div>
                                </div>

                            </div>
                            <div className="your-wills__settings">
                                <div className="will-date__row will-date__row--checkbox">
                                    <div className="will-date__row-input">
                                        <input id="wills-set1" type="checkbox" onChange={this.changeMessage} disabled={true} className="form-check form-check-input mt-0" />
                                        <label htmlFor="wills-set1">Add NFT Message (coming soon)</label>
                                    </div>
                                    <div className="your-wills__info-message" data-title={tooltipText.NFTMessage}>
                                        <img src={infoBtn} alt="Info"></img>
                                    </div><br />
                                </div>
                                <div className="your-wills__notifications" style={this.state.messageOn === true ? { display: 'block' } : { display: 'none' }}>
                                    <span>The message is stored encrypted and can only be read by the recipient when the will is received.</span>
                                    <textarea placeholder="NFT message"></textarea>
                                </div>
                                <div className="will-date__row will-date__row--checkbox">
                                    <div className="will-date__row-input">
                                        <input id="wills-set2" type="checkbox" onChange={this.changeDelivery} disabled={true} className="form-check form-check-input mt-0" />
                                        <label htmlFor="wills-set2">Automatic token delivery (coming soon)</label><br />
                                    </div>
                                    <div className="your-wills__info-message" data-title={tooltipText.delivery}>
                                        <img src={infoBtn} alt="Info"></img>
                                    </div><br />
                                </div>
                                <div className="your-wills__notifications" style={this.state.deliveryOn === true ? { display: 'block' } : { display: 'none' }}>
                                    <span>Once the condition is met, the bequeathed tokens will be automatically sent to the trusted wallet (10 USDT).</span>
                                </div>
                                <div className="will-date__row will-date__row--checkbox">
                                    <div className="will-date__row-input">
                                        <input id="wills-set3" type="checkbox" onChange={this.changeNotifications} disabled={false} className="form-check form-check-input mt-0" />
                                        <label htmlFor="wills-set3">Notifications</label><br />
                                    </div>
                                    <div className="your-wills__info-message" data-title={tooltipText.notifications}>
                                        <img src={infoBtn} alt="Info"></img>
                                    </div><br />
                                </div>
                                <div className="your-wills__notifications" style={this.state.notificationsOn === true ? { display: 'block' } : { display: 'none' }}>

                                    <span>Set up alerts in Telegram, Email or Google Calendar and dWill will notify you of all important events
                                        related to your dWills and dWills intended for you.
                                    </span>
                                    <a href="https://t.me/thewill_bot" rel="noreferrer" className="your-wills__links" target="_blank">
                                        <img src={btnTelegram} alt="Telegram"></img>
                                        <img src={btnEmail} alt="Email"></img>
                                        <span>Setting up notifications in Telegram and email</span>
                                    </a>
                                    <div className="your-wills__links">
                                        <a href={`http://www.google.com/calendar/event?action=TEMPLATE&text=${'dWill notification. dWill time expired.'}&dates=${this.state.googleCalendarDateText}/${this.state.googleCalendarDateText}&details=${`<div><b>ℹ️ dWill notification:</b></div><br/><div>The time to unlock the dWill has expired.</div><br/<div>Heir: <a href="${this.props.networkProvider + '/address/' + this.state.heirAddress}">${this.state.heirAddressShort}</a></div><br/><br/><div>You can see more info on our website.</div><br/><a href="https://dwill.app"><b>dWill.app</b></a>`}&trp=false&sprop=&sprop=name:`} target="_blank" rel="noreferrer"><img src={btnCalendar}></img>Add an event to Google Calendar</a>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div>
                                <ul className="your-wills__footer">
                                    <li>
                                        <Button variant="primary" disabled={
                                            (this.state.approved === true)
                                            ||
                                            (this.state.isAddress === false)
                                            ||
                                            (this.state.amount === '0')
                                            ||
                                            (this.state.amount === '')
                                            ||
                                            (this.state.tokensValue === '')
                                            ||
                                            (this.state.heirAddress === '')
                                            ||
                                            (this.state.year === '' || this.state.month === '' || this.state.day === '')
                                            ||
                                            (this.state.year === 0 && this.state.month === 0 && this.state.day === 0)
                                            ||
                                            (isNaN(parseInt(this.state.year)) || isNaN(parseInt(this.state.month)) || isNaN(parseInt(this.state.day)))
                                        } onClick={
                                            this.state.approved !== false
                                                ||
                                                (this.state.amount !== '0')
                                                ||
                                                (this.state.amount !== '')
                                                ||
                                                (this.state.heirAddress !== '')
                                                ||
                                                (this.state.isAddress === true)
                                                ||
                                                (this.state.tokensValue === '')
                                                ||
                                                (this.state.year !== '' || this.state.month !== '' || this.state.day !== '')
                                                ||
                                                (this.state.year !== 0 && this.state.month !== 0 && this.state.day !== 0)
                                                ||
                                                (isNaN(parseInt(this.state.year)) || isNaN(parseInt(this.state.month)) || isNaN(parseInt(this.state.day)))
                                                ? this.approve : null} style={
                                                    {
                                                        "background":
                                                            (this.state.approved === true)
                                                                ||
                                                                (this.state.amount === '0')
                                                                ||
                                                                (this.state.amount === '')
                                                                ||
                                                                (this.state.tokensValue === '')
                                                                ||
                                                                (this.state.heirAddress === '')
                                                                ||
                                                                (this.state.isAddress === false)
                                                                ||
                                                                (this.state.year === '' || this.state.month === '' || this.state.day === '')
                                                                ||
                                                                (this.state.year === 0 && this.state.month === 0 && this.state.day === 0)
                                                                ||
                                                                (isNaN(parseInt(this.state.year)) || isNaN(parseInt(this.state.month)) || isNaN(parseInt(this.state.day)))
                                                                ? '#CBD5E1' : '#7fd3ab'
                                                    }
                                                } >
                                            Approve
                                        </Button>
                                        <div className="your-wills__info-message" data-title={tooltipText.approve}>
                                            <img src={infoBtn}></img>
                                        </div>
                                    </li>
                                    <li>
                                        <Button variant="primary" disabled={
                                            (this.state.approved === false)
                                            ||
                                            (this.state.amount === '0')
                                            ||
                                            (this.state.amount === '')
                                            ||
                                            (this.state.heirAddress === '')
                                            ||
                                            (this.state.isAddress === false)
                                            ||
                                            (this.state.tokensValue === '')
                                            ||
                                            (this.state.year === '' || this.state.month === '' || this.state.day === '')
                                            ||
                                            (this.state.year === 0 && this.state.month === 0 && this.state.day === 0)
                                            ||
                                            (isNaN(parseInt(this.state.year)) || isNaN(parseInt(this.state.month)) || isNaN(parseInt(this.state.day)))
                                        } onClick={
                                            this.state.approved === false
                                                ||
                                                (this.state.amount === '0')
                                                ||
                                                (this.state.amount === '')
                                                ||
                                                (this.state.heirAddress === '')
                                                ||
                                                (this.state.isAddress === false)
                                                ||
                                                (this.state.tokensValue === '')
                                                ||
                                                (this.state.year === '' || this.state.month === '' || this.state.day === '')
                                                ||
                                                (this.state.year === 0 && this.state.month === 0 && this.state.day === 0)
                                                ||
                                                (isNaN(parseInt(this.state.year)) || isNaN(parseInt(this.state.month)) || isNaN(parseInt(this.state.day)))
                                                ? null : this.newWill} style={
                                                    {
                                                        "background":
                                                            (this.state.approved === false)
                                                                ||
                                                                (this.state.amount === '0')
                                                                ||
                                                                (this.state.amount === '')
                                                                ||
                                                                (this.state.isAddress === false)
                                                                ||
                                                                (this.state.heirAddress === '')
                                                                ||
                                                                (this.state.tokensValue === '')
                                                                ||
                                                                (this.state.year === '' || this.state.month === '' || this.state.day === '')
                                                                ||
                                                                (this.state.year === 0 && this.state.month === 0 && this.state.day === 0)
                                                                ||
                                                                (isNaN(parseInt(this.state.year)) || isNaN(parseInt(this.state.month)) || isNaN(parseInt(this.state.day)))
                                                                ? '#CBD5E1' : '#7fd3ab'
                                                    }}
                                            className='button_make-new-will'>
                                            <span className="button_number-span">Create a dWill</span>
                                        </Button>

                                    </li>
                                </ul>
                            </div>
                        </Modal.Footer>
                    </div>


                </Modal>
            </div>
                <Modal id='modal_confirm' show={this.state.showConfirm} className="modal-confirm">
                    <Modal.Header>
                        <h2 className='modal-confirm_h2'>Pending  transaction</h2>
                    </Modal.Header>
                    <div className="ml-loader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>

                    <Modal.Footer>
                        <p className="modal-confirm_text">Please confirm transaction in your web3 wallet</p>
                    </Modal.Footer>
                </Modal>
                <Modal className="modal-loading modal-loading--process" show={this.state.showEventConfirmed}>
                    <Modal.Header>
                        <div className="modal_confirm">
                            <h2 className="modal-loading__title modal-loading__title--confirmed">Confirmed!</h2>
                            <p className="modal-loading__subtitle">{this.state.confirmedText}</p>
                            <div className="modal-loading__progress-bar modal-loading__progress-bar--confirmed">
                                <span></span>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Footer>
                        <a className="modal-loading__link" href={`${this.props.networkProvider}/tx/${this.state.hash}`} target="_blank" rel="noreferrer">
                            <img src={linkBtn} alt="Provider"></img>
                        </a>
                        <Button variant="danger" onClick={this.handleCloseEventConfirmed} className="btn btn-danger">
                            <img src={closePic} alt="Close"/>
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal className="modal-loading modal-loading--process" show={this.state.showAwait}>
                    <Modal.Header>
                        <div className="modal_confirm">
                            <h2 className="modal-loading__title modal-loading__title--processing">Processing...</h2>
                            <p className="modal-loading__subtitle">{this.state.processingText}</p>
                            <div className="modal-loading__progress-bar modal-loading__progress-bar--processing">
                                <span></span>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Footer>
                        <Button variant="danger" onClick={this.handleCloseAwait} className="btn btn-danger">
                            <img src={closePic} alt="Close"/>
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={this.state.newWillDone} className="modal-await">
                    <img id="modal-done-image" src={ConfiPic} alt="confi" />
                    <Modal.Footer>
                        <button className="btn-close-modal btn btn-primary" onClick={this.handleCloseDoneNewWill}>
                            <img src={closeModalPic} alt="Close"></img>
                        </button>
                        <p className="modal-await_text">The dWill was successfully created!</p>
                        <p className="modal-await_text modal-await_text__second">
                            <a href={`${this.props.networkProvider}/tx/${this.state.hash}`} target="_blank" rel="noreferrer">
                                View in blockchain explorer
                            </a>
                        </p>
                    </Modal.Footer>
                </Modal>
                <Modal className="modal-loading modal-loading--process" show={this.state.showError}>
                    <Modal.Header>
                        <div className="modal_confirm">
                            <h2 className="modal-loading__title modal-loading__title--error">Error</h2>
                            <div className="modal-loading__subtitle">{this.state.errortext}</div>
                            <div className="modal-loading__progress-bar modal-loading__progress-bar--error">
                                <span></span>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Footer>
                        <Button variant="danger" className="btn btn-danger" onClick={this.handleCloseError}>
                            <img src={closePic} alt="Close"/>
                        </Button>
                    </Modal.Footer>
                </Modal>
                <div className='overlay'></div></>
        )
    }
}

export default NewWill 
